function Navbar({ onAdd }) {
  return (
    <div style={{
      padding: "15px",
      background: "#222",
      color: "#fff",
      display: "flex",
      justifyContent: "space-between"
    }}>
      <h2>Task Manager</h2>
      <button onClick={onAdd}>Add Task</button>
    </div>
  );
}

export default Navbar;